import type {CrewingRoleAccess} from './crewingRoleAccess'

/** Super Admin may complete drafts; other office users see submitted records. */
export function canViewCrewFinancialDrafts(
  actor: Pick<CrewingRoleAccess, 'isSuperAdmin' | 'isOfficeRole'>
): boolean {
  return actor.isSuperAdmin || !actor.isOfficeRole
}

export function canShowOvertimeStatusFilter(
  actor: Pick<CrewingRoleAccess, 'isSuperAdmin' | 'isCompanyGroupAdmin' | 'isCompanyAdmin'>
): boolean {
  return actor.isSuperAdmin || (!actor.isCompanyGroupAdmin && !actor.isCompanyAdmin)
}
